module.exports = __webpack_public_path__ + "img/9788946043664.1c87370d.jpg";